import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { FavoriteItem, FavoriteItemType } from '../../../modules/auth'
import MainModule from '../../../modules/main'
import { getContentTypeFromUrl } from '../../../utils/gtm/utilities'

export interface LvcFavoriteIconButton {
  dataId: number
  dataType: FavoriteItemType
  liked: boolean
  dataGtmId: string
  dataGtmName: string
  dataGtmBrand: string
  dataGtmCategory: string
  dataGtmCategory2: string
  dataGtmCategory3: string
  dataGtmCategory4: string
}

interface FavoriteStatusUpdateEvent {
  type: FavoriteItemType
  id: number
  favorite: true
}

export class LvcFavoriteIconButton extends MinzeElement {
  attrs: Attrs = [
    'data-id',
    'data-type',
    'data-gtm-name',
    'data-gtm-brand',
    'data-gtm-category',
    'data-gtm-category2',
    'data-gtm-category3',
    'data-gtm-category4',
    'data-width',
    'data-height',
  ]
  reactive: Reactive = [['isFavorited', false]]

  onClick = async (event: Event) => {
    event.preventDefault()
    event.stopPropagation()
    const mainModule = MainModule.getInstance()
    try {
      if (!this.isFavorited) {
        this.gtmData = {
          event: 'add_to_wishlist',
          ecommerce: {
            items: [
              {
                item_id: typeof this.dataId === 'boolean' ? '' : this.dataId || '', //id
                item_name: typeof this.dataGtmName === 'boolean' ? '' : this.dataGtmName || '', //name
                item_brand: typeof this.dataGtmBrand === 'boolean' ? '' : this.dataGtmBrand || '', //artist
                item_category:
                  typeof this.dataGtmCategory === 'boolean' ? '' : this.dataGtmCategory || '', //category
                item_category2:
                  typeof this.dataGtmCategory2 === 'boolean' ? '' : this.dataGtmCategory2 || '', //place
                item_category3:
                  typeof this.dataGtmCategory3 === 'boolean' ? '' : this.dataGtmCategory3 || '', //date
                item_category4:
                  typeof this.dataGtmCategory4 === 'boolean' ? '' : this.dataGtmCategory4 || '', // gratuit | billet
                content_type: getContentTypeFromUrl(window.location.pathname),
              },
            ],
          },
        }
        mainModule.analyticsSetCustomData(this.gtmData)
      }
    } catch (error) {
      console.error('Error setting GTM data:', error)
    }
    try {
      await mainModule.getAuth().saveItemToFavorites(this.dataId, this.dataType)
    } catch (error) {
      console.error('Error saving item to favorites:', error)
    }
  }

  updateButton = (isFavorited: boolean) => {
    this.isFavorited = isFavorited
    this.rerender(true)
  }

  onFavoriteStatusUpdate = (event: Event) => {
    const detail = (event as CustomEvent<FavoriteStatusUpdateEvent>).detail

    if (this.dataId === detail.id && this.dataType === detail.type) {
      this.updateButton(detail.favorite)
    }
  }

  updateFavoritesData(event: Event, dataId: number, dataType: FavoriteItemType) {
    const detail = (event as CustomEvent).detail
    const favorites: FavoriteItem[] = detail.favorites
    this.updateButton(!!favorites.find(item => item.id === dataId && item.type === dataType))
  }

  onReady() {
    const mainModule = MainModule.getInstance()
    const favorites: FavoriteItem[] = mainModule.getAuth().getFavorites()
    this.updateButton(
      !!favorites.find(item => item.id === this.dataId && item.type === this.dataType)
    )
  }

  html = () => `
    ${
      this.isFavorited
        ? `
      <lvc-favorite-heart-icon-filled>`
        : `
      <lvc-favorite-heart-icon>
      `
    }
  `

  css = () => `
    :host {
      background: white;
      display: flex;
      border-radius: 100%;
      width: ${this.dataWidth || '30px'};
      height: ${this.dataWidth || '30px'};
      align-items: center;
      justify-content: center;
      background: linear-gradient(100deg, #FFFFFF 5%, #BFF0FF 148.15%);
      background-size: 300%;
      transition: background 0.2s ease;
    }
    :host(:hover) {
      background-size: 100%;
    }
    lvc-favorite-heart-icon, lvc-favorite-heart-icon-filled {
      height: 17px;
      width: 18px;
      margin: auto;
    }
   `
  eventListeners: EventListeners = [
    [this, 'click', this.onClick],
    [window, 'lvc:item-favorite-status-update', this.onFavoriteStatusUpdate],
    [
      window,
      'lvc:user-data-updated',
      event => this.updateFavoritesData(event, this.dataId, this.dataType),
    ],
  ]
}
